<vectronic-selection-filter-with-header
  [title]="title()"
  [availableFilterItems]="items()"
  [selectedItem]="value()"
  [hideLabel]="true"
  [isFilterHidden]="!expanded()"
  (isFilterHiddenChange)="toggled.emit()"
  (selectedItemChange)="onSelectedItemChange($event)"
></vectronic-selection-filter-with-header>
